import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';

function SunIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}

function ThemeFab() {
  const { theme, toggleTheme } = useTheme();
  const { page } = useLanguage();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="theme-fab"
      onClick={toggleTheme}
      aria-label={isDark ? page.themeSwitchToLight : page.themeSwitchToDark}
      title={isDark ? page.themeSwitchToLight : page.themeSwitchToDark}
    >
      {isDark ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}

export default ThemeFab;
